import { HttpParams } from '@angular/common/http';
import { IHttpParamsOptions } from './http-params-options.interface';

export class ZorroInterceptorHttpParams extends HttpParams {

    constructor(
        public spinnerConfig: { spinnerMessage: string },
        params?: { [param: string]: string | string[] }) {
        super({ fromObject: params } as IHttpParamsOptions);
    }
}
